<template>
  <div class="form-container">
    <form @submit.prevent="validateBeforeSubmit($event)">
      <input id="email" type="email" name="EMAIL" placeholder="Enter email address" v-validate="'required|email'"/>
      <span class="newsletter-error" v-show="errors.has('EMAIL')" >
        <span></span>
        <p>{{ errors.first('EMAIL') }}</p>
      </span>
      <input type="submit" name="submit" value="submit" :class="{disabled:errors.has('EMAIL')}"  v-on:blur="resetForm()" data-vv-validate-on="none"/>
    </form>

    <div v-if="successMessage" class="thank-you">
      <p>Thank you for your submission</p>
    </div>
    <div v-if="errorMessage && !successMessage" class="thank-you">
      {{ errorMessage }}
    </div>
  </div>

</template>

<script>

export default {
  name: "MailchimpSubscribe",
  data: function() {
    return {
      email: '',
      response: {},
      errorMessage: null,
      successMessage: null
    };
  },
  ready: function() {
    return this.action = this.action.replace('/post?', '/post-json?').concat('&c=?');
  },
  methods: {
    resetForm: function(){
      this.$validator.reset();
      this.successMessage = '';
      this.errorMessage = '';
    },
    validateBeforeSubmit: function(e) {

        const mailChimpUrl = 'https://marcusthomasad.us1.list-manage.com/subscribe/post-json?u=3899716c72&id=b99c2efb2c&c=?';

        this.$validator.validateAll().then((result) => {
          if (result) {
            var params;
            params = $(e.currentTarget).serialize();

            return $.ajax({
              type: 'POST',
              url: mailChimpUrl,
              data: params,
              cache: false,
              dataType: 'jsonp',
              contentType: 'application/json; charset=utf-8',
              error: function (err) { _this.errorMessage = 'Could not connect to the registration server. Please try again later.'; },
              success: (function(_this) {
                return function(res) {

                  if (res.result === 'success') {
                    $('#email').val('');
                    return _this.successMessage = 'Thank you for your submission';
                  } else {
                    _this.successMessage = false;
                    _this.errorMessage = res.msg;

                    if (_this.errorMessage.indexOf('-') === -1){
                      return _this.errorMessage;
                    }
                    else {
                        return _this.errorMessage = _this.errorMessage.substring(0,_this.errorMessage.indexOf('-') - 1);
                    }

                  }
                };
              })(this)
            });

            return;
          }
        });
      },
  },
}
</script>



// WEBPACK FOOTER //
// newsletter.vue?837f43c4